import React from "react";

/**
 * Skeleton cohérent avec le layout des vraies cartes projet/produit.
 */
export const SkeletonCard = () => (
  <div className="flex flex-col bg-white rounded-none border border-[#E2E5F1] overflow-hidden">
    <div className="aspect-[4/3] bg-[#F1F3FB] animate-pulse" />
    <div className="p-6 md:p-7 space-y-4">
      <div className="w-1/3 h-3 rounded bg-[#E2E5F1] animate-pulse" />
      <div className="w-3/4 h-7 rounded bg-[#E2E5F1] animate-pulse" />
      <div className="space-y-2 pt-1">
        <div className="w-full h-3.5 rounded bg-[#F1F3FB] animate-pulse" />
        <div className="w-5/6 h-3.5 rounded bg-[#F1F3FB] animate-pulse" />
      </div>
      <div className="pt-4 flex items-center justify-between border-t border-[#E2E5F1]">
        <div className="w-1/3 h-3 rounded bg-[#F1F3FB] animate-pulse" />
        <div className="w-20 h-3 rounded bg-[#F1F3FB] animate-pulse" />
      </div>
    </div>
  </div>
);

export const SkeletonGrid = ({ count = 6 }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {Array.from({ length: count }).map((_, i) => (
      <SkeletonCard key={i} />
    ))}
  </div>
);

export default SkeletonCard;
